import _ from 'lodash'

import { WorkspaceBidderForTable } from '../hooks/useGetBidders/types'
import { Schema } from './schema'

export const mapToFormField = (data: WorkspaceBidderForTable[]): Schema['workspaceBidderSids'] =>
  _.chain(data).keyBy('id').mapValues('sid').value()
